import React from 'react';
import PropTypes from 'prop-types';
import AlertHistory from '../../common/AlertHistory';

const AlertDetailsTab = ({ alertId }) => <AlertHistory alertId={alertId} />;

AlertDetailsTab.propTypes = {
  alertId: PropTypes.string.isRequired
};

export default AlertDetailsTab;
